export default __webpack_public_path__ + "static/yogi-d00ca1cc48ab74938a23d4359ef3fb01.webp";